export const PaymentExternalType = Object.freeze({
  None: 0,
  Tableapp: 1
})

export const PaymentAttendStatus = Object.freeze({
  Attended: 0,
  NoShow: 1,
  Cancel: 2
})
